var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2025_24872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20ZM8.75 7.5V12.5C8.75 13.1914 8.19141 13.75 7.5 13.75C6.80859 13.75 6.25 13.1914 6.25 12.5V7.5C6.25 6.80859 6.80859 6.25 7.5 6.25C8.19141 6.25 8.75 6.80859 8.75 7.5ZM13.75 7.5V12.5C13.75 13.1914 13.1914 13.75 12.5 13.75C11.8086 13.75 11.25 13.1914 11.25 12.5V7.5C11.25 6.80859 11.8086 6.25 12.5 6.25C13.1914 6.25 13.75 6.80859 13.75 7.5Z",
    fill: "#345980"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2025_24872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause_icon.20f3dbec7f62d6e0625badf19724a65e.svg";
export { ForwardRef as ReactComponent };